// extracted by mini-css-extract-plugin
export default {"formBtn":"styles_formBtn__mbL9Y","selectedFile":"styles_selectedFile__9cyxP","selectedFileName":"styles_selectedFileName__0SKtS","confirmMessage":"styles_confirmMessage__TxkTj"};